export const baseURL = "https://budget-manager-879.herokuapp.com"